import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconChats = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName, className);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 11 11"
      className={classes}
    >
      <path
        fill="currentColor"
        d="M10.55 11a.47.47 0 0 1-.33-.14L8.537 9.14H4.714c-.86 0-1.551-.7-1.551-1.55V6.4h-.7L.82 8.08a.5.5 0 0 1-.52.11.5.5 0 0 1-.3-.44v-6.2C0 .7.7 0 1.551 0h5.135c.86 0 1.551.7 1.551 1.55v2.11H9.45c.86 0 1.551.7 1.551 1.55v5.33c0 .19-.11.35-.29.42-.06.02-.11.03-.17.03zM4.724 4.58c-.35 0-.64.29-.64.64v2.37c0 .35.29.64.64.64h4.014c.12 0 .24.05.33.14L10.1 9.42v-4.2c0-.35-.29-.64-.64-.64zM1.551.92c-.35 0-.64.29-.64.64v5.12l1.03-1.05c.09-.09.2-.14.331-.14h.89v-.27c0-.86.702-1.55 1.552-1.55h2.603V1.55c0-.35-.29-.64-.64-.64H1.55z"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconChats.defaultProps = {
  className: null,
  rootClassName: null,
};

IconChats.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconChats;
